import React, {FC, KeyboardEventHandler, useMemo, useState} from "react";
import {Button} from "../../../../lib/src/components/form/Button";
import {useNavigate} from "react-router";
import {faQuestion} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Relation} from "../../../../lib/src/api/dto/Relation";
import {Callout} from "../../../../lib/src/components/content/Callout";
import DynamicDataTable from "../../../../lib/src/components/data-table/DynamicDataTable";
import {faExternalLink} from "@fortawesome/pro-solid-svg-icons";
import config from "../../config";
import {VatRate} from "../../../../lib/src/api/dto/VatRate";

const PAGINATION_STEP_SIZE = 15
interface ProjectSearchProps {
  relations: Relation[]
  vatRates: VatRate[]
}
export const RelationSearch: FC<ProjectSearchProps> = props => {
  const navigate = useNavigate()
  const {crmUrl} = config
  const [limit, setLimit] = useState(PAGINATION_STEP_SIZE)
  const [cursor, setCursor] = useState<number>(-1)

  const vatRatesLookupTable = props.vatRates.reduce((carry, item) => {
    carry.set(item.id, item)
    return carry
  }, new Map<string,VatRate>())

  const items = useMemo(() => {
    return [
      ...props.relations.map((relation) => {
        return {
          id: relation.id,
          name: relation.name,
          alias: relation.alias,
          status: relation.status,
          phone: relation.phone,
          locationAddressStreetname: relation.locationAddressStreetname,
          locationAddressHouseNumber: relation.locationAddressHouseNumber,
          locationAddressHouseNumberAddition: relation.locationAddressHouseNumberAddition,
          locationCity: relation.locationCity,
          locationZipcode: relation.locationZipcode,
          mailingAddressStreetname: relation.mailingAddressStreetname,
          mailingAddressHouseNumber: relation.mailingAddressHouseNumber,
          mailingAddressHouseNumberAddition: relation.mailingAddressHouseNumberAddition,
          mailingCity: relation.mailingCity,
          mailingZipcode: relation.mailingZipcode,
          web: relation.web,
          email: relation.email,
          paymentTerm: relation.paymentTerm,
          vatRate: relation.vatRateId,
          createdAt: relation.createdAt,
          updateAt: relation.updatedAt,
          navigate: () => navigate(`/relations/${relation.id}`),
          relation: relation
        }
      })
    ].sort((a, b) => a.updateAt.getTime() < b.updateAt.getTime() ? 1 : -1)
  }, [props.relations])

  const handleKeyDown: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === 'ArrowUp') {
      setCursor(old => Math.max(0, old - 1))
    }
    if (event.key === 'ArrowDown') {
      setCursor(old => Math.min(items.length - 1, limit - 1, old + 1))
    }
    if (event.key === 'Enter' || event.key === 'Tab') {
      const item = items[cursor]
      if (! item) {
        console.warn(`Cannot find item on cursor position ${cursor}`, item, items)
      } else {
        item.navigate()
      }
    }
  }

  return <div>
    {/*header*/}
    <div className={'flex justify-between items-end'}>
      <h1 className={'text-3xl'}>Leveranciers</h1>
    </div>

    <Callout>
      <div className={'flex justify-between items-center'}>
        <div>Beheer de leveranciers in de CRM omgeving</div>
        <Button type={'primary'} size={'md'} text={'Naar CRM'} icon={faExternalLink} onClick={() => {window.location.href = `${crmUrl}/suppliers`}} />
      </div>
    </Callout>

    <div className={''}>
      {props.relations.length === 0 && <div className={'flex flex-col bg-slate-100 border-2 border-slate-200 h-64 rounded-sm items-center justify-center'}>
        <FontAwesomeIcon icon={faQuestion} className={'text-3xl'} />
        <h1 className={'pb-2'}>Er zijn nog geen relaties</h1>
      </div>}

      <DynamicDataTable
        className={'text-sm'}
        data={items}
        compact={true}
        availableFilters={[]}
        searchableProperties={['name', 'email', 'phone']}
        placeholder={<>Geen relaties kunnen vinden</>}
        keyProperty={'id'} columns={[
          {
            header: 'Naam',
            property: 'name'
          },
          {header: 'Adress',
           property: 'locationAddressStreetname',
           transform: (_, row) => {
            const r = props.relations.find((r) => r.id === row.id)
            return <div>
              {r?.locationAddressStreetname ?
                <span>{`${r?.locationAddressStreetname ?? ''} ${r?.locationAddressHouseNumber ?? ''}${r?.locationAddressHouseNumberAddition ?? ''}, ${r?.locationCity ?? ''}`}</span>
                : <div>{'-'}</div>
              }
            </div>
          }},
          {
            header: 'Email',
            property: 'email',
            transform: (email, _) => {
              return <div>{email ?? '-'}</div>
            }
          },
          {
            header: 'Telefoon',
            property: 'phone',
            transform: (phone, _) => {
              return <div>{phone ?? '-'}</div>
            }
          },
          {header: 'BTW',
           property: 'vatRate',
           transform: (id) => vatRatesLookupTable.get(id!)?.rate ?? '-'
          },
        ]}
      />

    </div>
  </div>
}